import React from 'react';
import styled from 'styled-components/macro';
import { CustomPiece } from '../../../../../lib/modelBuilder/pieces/CustomPiece';
import { Drawer } from '../../../../../lib/modelBuilder/pieces/Drawer';
import StyledDimensionValue from '../../../styles/StyledDimensionValue';

interface Props {
  drawer: CustomPiece<Drawer>;
  isLastDrawer: boolean;
}

const DrawerSchemaDimensions = ({ drawer, isLastDrawer }: Props) => {
  return (
    <StyledDrawerSchema
      heightDrawer={drawer.height}
      isLastDrawer={isLastDrawer}
    >
      <div className="absolute h-full w-full flex items-center justify-start">
        <StyledDimensionValue small>{drawer.height / 10}</StyledDimensionValue>
      </div>
      <div className="absolute h-full w-full flex items-center justify-center">
        <hr className="w-12 border-black border-2" />
      </div>
    </StyledDrawerSchema>
  );
};

const StyledDrawerSchema = styled.div<{
  heightDrawer: number;
  isLastDrawer: boolean;
}>`
  grid-row-end: span 1;
  position: relative;
  border-bottom: ${p => (p.isLastDrawer ? 'none' : '1px solid black')};
`;

export default DrawerSchemaDimensions;
